
import { REQUEST_SOURCE_TRACK_EVENTS, REQUEST_SOURCE_TRACK_EVENTS_ERROR, RECEIVE_SOURCE_TRACK_EVENTS } from 'actions'

const initialState = {}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case REQUEST_SOURCE_TRACK_EVENTS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          [payload.sourceSlug]: {
            hasRequested: false,
            isRequesting: true,
            didRequestFail: false,
            data: {}
          }
        }
      }
    case REQUEST_SOURCE_TRACK_EVENTS_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          [payload.sourceSlug]: {
            hasRequested: true,
            isRequesting: false,
            didRequestFail: true,
            data: {}
          }
        }
      }
    case RECEIVE_SOURCE_TRACK_EVENTS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          [payload.sourceSlug]: {
            hasRequested: true,
            isRequesting: false,
            didRequestFail: false,
            data: toEventNameMap(payload.response)
          }
        }
      }
    default:
      return state
  }
}

function toEventNameMap (events) {
  const map = {}
  for (let i = 0; i < events.length; i++) {
    const event = events[i]
    map[event.name] = event
  }
  return map
}



// WEBPACK FOOTER //
// ./reducers/source-track-events.js